import { createContext, useEffect, useReducer, useState } from 'react';
// utils
import axios from '../utils/axios';
import { setSession } from '../utils/jwt';
 
// ----------------------------------------------------------------------

export interface UserData {
  codigo: number;
  nome: string;
  perfil: any;
  email: string;
  alterarSenha: string;
  statusModel: statusModel;
  versaoDesenvolvedor?: boolean;
}

interface statusModel {
  codigo: number;
  nome: string;
}

export interface TelasSistema {
  codigo: number;
  nome: string;
  permissoes: Array<Permissoes>;
}

interface Permissoes {
  codigo: number;
  nome: string;
}

export interface SistemaGPSIDModel {
  codigo: number;
  nome: string;
  link: string;
  telasSistema: Array<TelasSistema>;
}

export interface ResponseDataLogin {
  token: string;
  tipo: string;
  numerosCRs: string;
  usuarioData: UserData;
  sistema: Array<SistemaGPSIDModel>;
}

const initialState = {
  isAuthenticated: false,
  isInitialized: false,
  user: null,
};

const handlers = {
  INITIALIZE: (state, action) => {
    const { isAuthenticated, user } = action.payload;
    return {
      ...state,
      isAuthenticated,
      isInitialized: true,
      user,
    };
  },
  LOGIN: (state, action) => {
    const { user } = action.payload;

    return {
      ...state,
      isAuthenticated: true,
      user,
    };
  },
  LOGOUT: (state) => ({
    ...state,
    isAuthenticated: false,
    user: null,
  }),
  REGISTER: (state, action) => {
    const { user } = action.payload;

    return {
      ...state,
      isAuthenticated: true,
      user,
    };
  },
};

const reducer = (state, action) => (handlers[action.type] ? handlers[action.type](state, action) : state);

// interface AppContextData {
//   update: (id: any) => Promise<void>;
//   setAplicativos: (data: any) => void;
//   convertData: (id: any) => void;

//   data: ItemAPP[];
//   aplicativos: ItemAPP[];
// }

// const AppContext = createContext<AppContextData>({} as AppContextData);

interface AppContextData {
  method: 'jwt';
  login: () => Promise<void>;
  logout: () => Promise<void>;
  register: () => Promise<void>;
  accessTokenState: '';
  sistemaData: SistemaGPSIDModel[];
  aplicativosData: SistemaGPSIDModel[];
  // initialState: {
  isAuthenticated: boolean;
  isInitialized: boolean;
  user: UserData;
  // };
}

const AuthContext = createContext<AppContextData>({} as AppContextData);

// const AuthContext = createContext({
//   ...initialState,
//   method: 'jwt',
//   login: () => Promise.resolve(),
//   logout: () => Promise.resolve(),
//   register: () => Promise.resolve(),
//   accessTokenState: '',
//   sistemaData: [],
//   aplicativosData: [],
// });

// ----------------------------------------------------------------------


function AuthProvider({ children }) {
  const [state, dispatch] = useReducer(reducer, initialState);
  const [accessTokenState, setAccessTokenState] = useState('');

  useEffect(() => {
    const initialize = async () => {
      try {
        const accessToken = window.localStorage.getItem('gpshub:accessToken');
        const userData = window.localStorage.getItem('gpshub:user');

        // if (accessToken && isValidToken(accessToken)) {
        setSession(accessToken);
        if (accessToken) {
          setAccessTokenState(accessToken);
          let user = null;

          // const response = await axios.get('/api/account/my-account');
          // const { user } = response.data;
          // const { logins } = db

          // if(userData) user = logins[0].user
          if (userData) user = JSON.parse(userData);


          dispatch({
            type: 'INITIALIZE',
            payload: {
              isAuthenticated: true,
              user,
            },
          });
        } else {
          dispatch({
            type: 'INITIALIZE',
            payload: {
              isAuthenticated: false,
              user: null,
            },
          });
        }
      } catch (err) {
        console.error(err);
        dispatch({
          type: 'INITIALIZE',
          payload: {
            isAuthenticated: false,
            user: null,
          },
        });
      }
    };

    initialize();
  }, []);

  const login = async (email, password) => {
 
      
      const response = await axios.post('/login/logar', {
        email,
        password,
      });

      if(!response?.data && !response?.data?.token){
      return
      }
   
      const { token, usuarioData } = response.data;

      
      axios.defaults.headers.common.Authorization = 'Bearer ' + response.data.token;
   
      window.localStorage.setItem('gpshub:accessToken', token);
      window.localStorage.setItem('gpshub:user', JSON.stringify(usuarioData));
      setSession(token);
       dispatch({
        type: 'LOGIN',
        payload: {
          user: usuarioData,
        },
      });

       
  };

  /* const login = async (email, password) => {
    try {
      // const responseLogin = await axios.post<ResponseDataLogin>('/gpsid', {
      //   login: email,
      //   password,

      // });
     
      axios.defaults.headers.common.Authorization = 'Bearer ' + responseLogin.data.token;
  
      const { token, usuarioData, numerosCRs } = responseLogin.data;

      if (window?.localStorage) {
        window.localStorage.setItem('gpshub:accessToken', token);

        window.localStorage.setItem('gpshub:user', JSON.stringify(usuarioData));
      }
      setSession(token);
      setAccessTokenState(token);
      dispatch({
        type: 'LOGIN',
        payload: {
          user: usuarioData,
        },
      });
      setTimeout(() => {
        window.location.reload();
      }, 2500);
    } catch (e) {
      throw new Error(e.message);
    }
  };
  */
  const register = async (email, password, firstName, lastName) => {
    const response = await axios.post('/api/account/register', {
      email,
      password,
      firstName,
      lastName,
    });
    const { accessToken, user } = response.data;

    window.localStorage.setItem('accessToken', accessToken);
    dispatch({
      type: 'REGISTER',
      payload: {
        user,
      },
    });
  };

  const logout = async () => {
    setSession(null);
    window.localStorage.removeItem('gpshub:user');
    window.localStorage.removeItem('gpshub:accessToken');

    dispatch({ type: 'LOGOUT' });
  };

  return (
    <AuthContext.Provider
      value={{
        ...state,
        method: 'jwt',
        login,
        logout,
        accessTokenState,
        register
      }}
    >
      {children}
    </AuthContext.Provider>
  );
}

export { AuthContext, AuthProvider };
